var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.EntityOverview,{attrs:{"name":'POIs',"entityType":'poi',"configAction":'getApiKeys',"latestDataEndpoint":_setup.env.news_api_client_url + 'poi',"matomoEndpoint":'https://matomo.api.eo-heimat.de',"matomoSiteId":_setup.isDevEnvironment ? 3 : 4,"matomoTokenAuth":'72d0c8747156029f020882bb77535ca1'}})
}
var staticRenderFns = []

export { render, staticRenderFns }